import React from "react";
import { useTheme } from "../../../../contexts/ThemeContext";
import { BucketType } from "../../../../types/blob";

interface BucketTabsProps {
  activeTab: BucketType;
  onTabChange: (tab: BucketType) => void;
}

const BucketTabs: React.FC<BucketTabsProps> = ({ activeTab, onTabChange }) => {
  const { theme } = useTheme();
  const isDarkMode = theme === "dark";

  const tabs: { id: BucketType; label: string }[] = [
    { id: "provider", label: "Provider Files" },
    { id: "runplutus", label: "RunPlutus Files" },
  ];

  return (
    <div className="flex space-x-1 rounded-lg bg-opacity-50 p-1">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={`px-4 py-2 text-sm font-medium rounded-md transition-all ${
            activeTab === tab.id
              ? isDarkMode
                ? "bg-teal-600 text-rp-grey"
                : "bg-teal-500 text-white"
              : isDarkMode
                ? "text-rp-grey/50 hover:text-rp-grey hover:bg-rp-surface-raised"
                : "text-gray-600 hover:text-gray-900 hover:bg-gray-100"
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default BucketTabs;

